import { SeeClientsEnum } from '@uplift/types';
import { ButtonStyleRadio, ButtonStyleRadioGroup } from '@uplift/ui-v2';
import { seeClientsTypeLabel } from '../profile.utils';
import { makeStyles } from 'tss-react/mui';
import { InPersonSupportChip } from './SessionOptionsForm.component';
import { AddressSessionOptionFormType } from './types';
import { useFormikContext } from 'formik';

export const ServiceTypeForm: React.VFC = () => {
  const formik = useFormikContext<AddressSessionOptionFormType>();
  const { classes } = useServiceTypeFormStyles();

  const seeClientsTypeValue = formik.values.seeClientsType;

  return (
    <ButtonStyleRadioGroup name="seeClientsType" label="">
      {[ SeeClientsEnum.telehealth, SeeClientsEnum.inPerson, SeeClientsEnum.videoAndInPerson ].map((seeClientsType) => {
        const showInPersonChip = [ SeeClientsEnum.inPerson, SeeClientsEnum.videoAndInPerson ].includes(seeClientsTypeValue) && seeClientsType === seeClientsTypeValue;

        return (
          <ButtonStyleRadio key={seeClientsType} value={seeClientsType} className={classes.relative}>
            {seeClientsTypeLabel[seeClientsType]}
            {showInPersonChip && <InPersonSupportChip className={classes.chip} />}
          </ButtonStyleRadio>
        );
      })}
    </ButtonStyleRadioGroup>
  );
};

const useServiceTypeFormStyles = makeStyles({ name: 'ServiceTypeForm' })(theme => ({
  relative: {
    position: 'relative',
  },
  chip: {
    position: 'absolute',
    left: '100%',
    marginLeft: theme.spacing(2),
    pointerEvents: 'none',
  }
}));
